<template>
  <m-scrollbar>
    <history />
  </m-scrollbar>
</template>

<script>
import MScrollbar from '@/components/MScrollbar'
import History from '@/components/account/payments/history/History'

export default {
  components: { MScrollbar, History },
  mounted () {
    this.dispatchGetting()
  },
  watch: {
    '$route' (to, from) {
      this.dispatchGetting()
    },
    '$i18n.locale' (to, from) {
      this.dispatchGetting()
    }
  },
  methods: {
    dispatchGetting () {
      this.$store.dispatch('account/GET_PAYMENTS', {
        params: {
          from: this.$route.params.from,
          to: this.$route.params.to
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/payments/history/View.vue